import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className="footer-bg d-flex justify-content-evenly align-items-center m-0 p-0">
            <h1 className="text-light text-center p-5">FOOTER</h1>
        </div>
    )
}

export default Footer;
